import { RootState } from 'theSource/app/store';

export const selectActiveHeader = (state: RootState) =>
  state.enrollment.header.activeHeader;

export const selectMaxHeaderItem = (state: RootState) =>
  state.enrollment.header.maxHeaderItem;

export const selectHeaderItems = (state: RootState) =>
  state.enrollment.header.headerItems;

export const selectPerPayPeriodCost = (state: RootState) => {
  return state.enrollment.header.perPayPeriodCost;
};

export const selectIsLoadingBenefits = (state: RootState) => {
  return state.enrollment.header.isLoadingBenefits;
};
